export const localReference = {
    companyAuditLocalEnum: [{"label":"未认证","value":-1,"key":"NOT"},{"label":"认证中","value":0,"key":"WAIT"},{"label":"已认证","value":1,"key":"PASS"},{"label":"认证失败","value":2,"key":"REJECT"}],
    accountTypeEnum: [{"label":"个人","value":0,"key":"PERSONAL"},{"label":"企业","value":1,"key":"COMPANY"}],
  }